import room from './room'

export default {
  room
}
